import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useMutation, useQueryClient } from 'react-query'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import withApiData from '../HOC/withApiData'
import colors from '../../configuration/colors'
import { hideModal } from '../../actions/modal'
import Modal from '../mini/Modal'
import Button from '../mini/Buttons/Button'
import CancelButton from '../mini/Buttons/CancelButton'
import H2 from '../typography/headers/H2'
import MarginRight15 from '../typography/margins/MarginRight15'
import SelectorComponent from './CreateOrEditCourseModal/InputComponents/SelectorComponent'
import { moveActivityToDifferentLevel } from '../mycourses/Activities/API'

const ModalContainer = styled.div`
  width: 660px;
  margin: 100px auto;
  border-radius: 10px;
  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.08);
  background-color: ${colors.smoke};
`

const HeaderContainer = styled.div`
  height: 80px;
  width: auto;
  border-radius: 10px 10px 0 0;
  background-color: ${colors.white};
  border-bottom: 1px solid ${colors.rock};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
`

const MainContainer = styled.div`
  padding: 10px 30px 30px;
`

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

const ChangeLevelForActivityModal = ({
  apiData,
  levels,
  currentLevelId,
  activityQuestId,
  activityQuestName,
  handleShouldExpandLevel,
  journeyId
}) => {
  const dispatch = useDispatch()
  const queryClient = useQueryClient()

  const [selectedLevel, setSelectedLevel] = useState(
    levels.find(l => l.id === currentLevelId)
  )

  const handleSelectedLevel = e => {
    setSelectedLevel(e)
  }

  const handleCloseModal = () => {
    dispatch(hideModal())
  }

  const createMutation = useMutation(
    ({ apiData, currentLevelId, activityQuestId, selectedLevel }) =>
      moveActivityToDifferentLevel(
        apiData,
        currentLevelId,
        activityQuestId,
        selectedLevel
      )
  )

  const handleChangeLevel = () => {
    createMutation.mutate(
      {
        apiData,
        currentLevelId,
        activityQuestId,
        selectedLevel: selectedLevel.id
      },
      {
        onSuccess: async () => {
          queryClient.setQueryData(['journey-levels-' + journeyId], ls => {
            return [...ls].map(nl => {
              if (nl.id === selectedLevel.id || nl.id === currentLevelId) {
                return { ...nl, ...{ just_created: true } }
              } else {
                return nl
              }
            })
          })
          await queryClient.refetchQueries(['journey-levels-' + journeyId])
          await queryClient.refetchQueries(['journey-level-' + currentLevelId])
          await queryClient.refetchQueries([
            'journey-level-' + selectedLevel.id
          ])
          await queryClient.refetchQueries([
            'level-activities-' + currentLevelId
          ])
          await queryClient.refetchQueries([
            'level-activities-' + selectedLevel.id
          ])

          handleCloseModal()

          const el = document.getElementById(`level-id-${selectedLevel.id}`)
          if (el) {
            el.scrollIntoView({
              behavior: 'smooth'
            })
          }
        }
      }
    )
  }

  return (
    <Modal
      width={1400}
      percentHeight={100}
      background={'rgba(36,54,70,0.48)'}
      lockBodyScroll={false}
      opacity={'.9'}
      allowInnerScroll
      allowCloseOnExternalClick={false}
    >
      <ModalContainer>
        <HeaderContainer>
          <H2>{activityQuestName}</H2>
          <FlexContainer>
            <MarginRight15>
              <CancelButton
                handleClick={handleCloseModal}
                title="Cancel"
                width="104px"
              />
            </MarginRight15>
            <Button
              width="104px"
              title="Save"
              handleClick={handleChangeLevel}
              buttonColor={colors.oeYellow}
              borderColor={colors.oeYellow}
              hoverBackground={colors.charcoal4}
              hoverColor={colors.white}
              shouldShowTooltipAndDisableButton={false}
            />
          </FlexContainer>
        </HeaderContainer>
        <MainContainer>
          <SelectorComponent
            placeholder="Level"
            handleSelectedValueChange={handleSelectedLevel}
            selectedValue={selectedLevel}
            options={levels}
            shouldDisplayAsterisk={false}
          />
        </MainContainer>
      </ModalContainer>
    </Modal>
  )
}

ChangeLevelForActivityModal.propTypes = {
  closeCallback: PropTypes.func,
  apiData: PropTypes.object.isRequired,
  levels: PropTypes.array.isRequired,
  currentLevelId: PropTypes.number.isRequired,
  activityQuestId: PropTypes.number.isRequired,
  activityQuestName: PropTypes.string.isRequired,
  handleShouldExpandLevel: PropTypes.func.isRequired,
  journeyId: PropTypes.number.isRequired
}

export default withApiData(ChangeLevelForActivityModal)



// WEBPACK FOOTER //
// ./src/components/modal/ChangeLevelForActivityModal.js